import { render, staticRenderFns } from "./_tabFights.vue?vue&type=template&id=4724fbc6&scoped=true&"
import script from "./_tabFights.vue?vue&type=script&lang=js&"
export * from "./_tabFights.vue?vue&type=script&lang=js&"
import style0 from "./_tabFights.vue?vue&type=style&index=0&id=4724fbc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4724fbc6",
  null
  
)

export default component.exports